<template>
  <div class='frame' >
     <div v-if="!loaded">
         客服加载中,请耐心等待
     </div>
     <iframe  v-show="loaded" @load="onload" :src="this.$store.state.online_service_url" style="width:100%;height:100%;"/>
  </div>
</template>

<script>
export default {
  name:"kefu",
  data(){
     return {
       loaded:false,

     }
  },
  
  methods:{
    
    onload(){
       this.loaded = true;
    }
    
  }
};
</script>

<style scoped>
.myinput {
   width: 100%;
    height: 40px;
    line-height: 1;
    font-size: 1rem;
    border-radius: 5px;
    border: none;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: Roboto,serif;
    text-align: left;
    margin-bottom: 20px;
    color:gray;
    outline:none;
}
.markets {
  display: flex;
  padding-top:20px;
  justify-content: space-evenly;
}
.markets-rate {
  margin-top: 20px;
  background-color: #fff;
}
.markets-rate dd {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 0;
}
.upper .uppercase {
  font-style: normal;
  text-transform: uppercase;
}
.up {
  
  font-size: 1rem;
}
.down {
  font-size: 0.8rem;
  color:darkgrey;
}
.em{
    background-color: #03ad8f;
    padding: 10px;
    border-radius: 6px;
    margin: 5px;
    color:white;
}
.loginclass {
      font-weight: 700;
    width: 50%;
    margin-top: 30px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid hsla(0,0%,100%,.25);
    background-color: hsla(0,0%,100%,.06);
    line-height: 40px;
    text-align: center;
    color: #fff;
    padding: 0 20px;
}
.frame {
    position: fixed;
    top:0px;
    bottom: 76px;
    left:0;
    right:0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/pages/Kefu.vue